module.exports = "/_next/static/images/track-cb1b6762035444a35e1aaf0e187d72a2.png";